export default "#ifdef GL_ES\nprecision highp float;\n#define GLSLIFY 1\n#endif\n\nvarying vec4 aColor;\n\nvoid main(void) {\n    gl_FragColor = aColor;\n}\n"